import { Controller, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { useGetEmrsQuery, useGetWorkspacesQuery } from '~/api/v2/hooks';
import { ButtonSpinner, SelectPlaceholder } from '~/components';

const WorkspaceField = () => {
  const projectId = +useParams().projectid!;
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const fieldValue = watch('notebook_id');

  const { data: emrData } = useGetEmrsQuery({ projectId });
  const { data: workspaces, isFetching: isWorkspacesLoading } = useGetWorkspacesQuery(
    { projectId, emrId: emrData?.id || 0 },
    { skip: !emrData?.id || !projectId },
  );

  return (
    <FormControlLabel
      label="WORKSPACE"
      disabled={isWorkspacesLoading}
      required
      control={
        <Controller
          name="notebook_id"
          control={control}
          render={({ field }) => (
            <>
              <FormHelperText error={!!errors.notebook_id}>
                {(errors?.notebook_id?.message as string) || 'Select the workspace for the job'}
              </FormHelperText>
              <Select
                {...field}
                value={field.value ?? ''}
                error={!!errors.notebook_id}
                startAdornment={isWorkspacesLoading && <ButtonSpinner />}
                renderValue={() => {
                  if (!fieldValue) return <SelectPlaceholder>Select the workspace</SelectPlaceholder>;

                  return fieldValue;
                }}
              >
                {workspaces?.map((el) => (
                  <MenuItem key={el} value={el}>
                    {el}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        />
      }
    />
  );
};

export default WorkspaceField;
